import { render, staticRenderFns } from "./personManager.vue?vue&type=template&id=70357052&scoped=true"
import script from "./personManager.vue?vue&type=script&lang=js"
export * from "./personManager.vue?vue&type=script&lang=js"
import style0 from "./personManager.vue?vue&type=style&index=0&id=70357052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70357052",
  null
  
)

export default component.exports